export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "all": [
    {
      title: "Release",
      cls: "bulk-release-order",
      icon: "paper-plane-o",
      disabled:true
    }
  ],
  "actions": [
    {
      title: "Cancel",
      cls: "cancel-order",
      icon: "ban",
      disabled:false
    },
    {
      title: "Release",
      cls: "release-order",
      icon: "paper-plane-o",
      disabled:false
    },
    {
      title: "Edit",
      cls: "edit-order",
      icon: "pencil",
      disabled:false
    }
  ]
};


// WEBPACK FOOTER //
// ./src/pages/order/filter/actionOptions.js